module.exports = __webpack_public_path__ + "static/media/edit-icon.4318084f.svg";